(function ($) {
	$('.product-parameters__param-drop').hide();
	$('.product-parameters__param').each(function () {
		let $param = $(this);
		$(this).children('.product-parameters__param_title').on("click", function () {
			$($param).children('.product-parameters__param-drop').slideToggle(300);
		});
	})
})(jQuery);
